import home from './home.js'
import blog from './blog.js'

export default {
  home,
  blog,
}
